// extracted by mini-css-extract-plugin
export default {"container":"LoggedIn_container__yRbrD","avatar":"LoggedIn_avatar__FpNuA","menu":"LoggedIn_menu__EVA59","menuText":"LoggedIn_menuText__Nhf9B"};